import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Button, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { deleteAssociatedDocumentThunk } from '../../../slices/thunks';
import { resetAssociatedDocumentFlags } from '../../../slices/associatedDocument/reducer';

const DeleteAssociatedDocumentModal = ({ dataAssociatedDocument, isOpen, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorAssociatedDocument = createSelector(
		state => state.AssociatedDocument,
		associatedDocument => ({
			isDeleting: associatedDocument?.isDeleting,
			isDeleted: associatedDocument?.isDeleted,
			isCloseModal: associatedDocument?.isCloseModal,
		})
	);

	const { isDeleting, isDeleted, isCloseModal } = useSelector(selectorAssociatedDocument);

	useEffect(() => {
		if (isOpen && isCloseModal && isDeleted) {
			dispatch(resetAssociatedDocumentFlags());
			handlerToggleModal();
		}
	}, [isCloseModal, isDeleted]);

	const handleDelete = () => {
		if (dataAssociatedDocument?._id) {
			dispatch(deleteAssociatedDocumentThunk(dataAssociatedDocument._id));
		}
	};

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={handlerToggleModal}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop='static'
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>¡Estás a punto de eliminar un Documento!</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en confirmar.
						</p>
						<p className='small'>
							Documento: {dataAssociatedDocument?.name || ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button
								className='btn-danger btn-label'
								onClick={handlerToggleModal}
								disabled={isDeleting}
							>
								<i className='ri-close-line label-icon'></i> Cancelar
							</Button>
							<button
								className='btn btn-label btn-primary'
								onClick={handleDelete}
								disabled={isDeleting}
							>
								{isDeleting
									? <i className='label-icon'><Spinner size='sm' /></i>
									: <i className='ri-check-double-line label-icon'></i>
								}
								{' '}Confirmar
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteAssociatedDocumentModal;
